/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import edit_icon from "../assests/images/onbording/editIcon.svg";
import { Space, Tooltip, Modal, Form, Spin, Button, message } from "antd";
import FirmInputDetails from "../views/Master/CpOnbordingSteps/FirmDetails/FirmInputDetails";
import FirmBankDetails from "../views/Master/CpOnbordingSteps/FirmDetails/FirmBankDetails";
import PersonalInputDetails from "../views/Master/CpOnbordingSteps/PersonalDetails/PersonalInputDetails";
import PersonalAddress from "../views/Master/CpOnbordingSteps/PersonalDetails/PersonalAddress";
import moment from "moment";
import { MiscellaneousInput } from "../views/Master/CpOnbordingSteps/Miscellaneous Details/MiscellaneousInput";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  patchOnboardForm,
  patchOnboardFormClear,
} from "../actionsMethods/masterMethods";
import EditDeliveryDetails from "../views/Master/CpOnbordingSteps/DeliveryDetails/EditDeliveryDetails";
import { BasicDetails } from "../views/Master/CpOnbordingSteps/BasicDetails";
import { AddressDetails } from "../views/Master/CpOnbordingSteps/AddressDetails";
// import EditDeliveryDetails from "../views/Master/CpOnbordingSteps/DeliveryDetails/EditDeliveryDetails";
export function ViewDetailsHeading({ text, itemkey, apiResponse, id }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  let userData = JSON.parse(localStorage.getItem("userinfo"));
  const [key, setKey] = useState(null);

  const [formValues, setFormValues] = useState([
    {
      id: Math.random().toString(36).slice(2),
      pinCode: "",
      areaName: [],
      disabledAreaName: [],
    },
  ]);

  const [form] = Form.useForm();

  const { error, result, fetching } = useSelector(
    (state) => state.masterReducer.patchOnboardFormReducer,
    shallowEqual
  );

  useEffect(() => {
    if (result) {
      // message.success("Details updated successfully");
      setVisible(false);
      form.resetFields();
      setKey(null);
      dispatch(patchOnboardFormClear());
    } else if (!fetching && error) {
      message.error(error?.message);
    }
  }, [fetching]);

  const showModal = (i) => {
    setKey(i);
    setVisible(true);
    if (itemkey == 3) {
      form.setFieldValue("CPPin", apiResponse?.premiseDetails?.pincode);
    }
  };
  let convertToDate = (date) => {
    let today = new Date(date);
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();
    today = `${dd}-${mm}-${yyyy}`;
    return today;
  };
  const calculetAreat = (values) => {
    let tempArea = [];
    for (let k = 0; k < formValues?.length; k++) {
      for (let i = 0; i < formValues[k]?.areaName?.length; i++) {
        for (
          let j = 0;
          j < values["Areaname" + formValues[k].id]?.length;
          j++
        ) {
          if (
            values["Areaname" + formValues[k].id][j] ===
            formValues[k].areaName[i].value
          ) {
            tempArea.push({
              pincode: values["CPPin" + formValues[k].id],
              area: {
                areaId: formValues[k].areaName[i].value,
                areaName: formValues[k].areaName[i].label,
              },
            });
          }
        }
      }
    }
    return tempArea;
  };
  const handleSubmit = (values) => {
    // let data1 ={

    // }
    let data2 = {
      firmDetailsDto: {
        gst: values?.GSTnumber || null,
        pan: values?.PANNumber,
        proprietorName: values?.nameOfProprietor,
        firmName: values?.NameOfFirm || null,
        firmType: values?.FirmType,
        gstRegistred:
          values?.IsGSTRegistered == undefined
            ? false
            : JSON?.parse(values?.IsGSTRegistered),
        msme: values?.MSME?.toString(),
        accountHolderName: values?.AccountHolderName,
        accountNo: values?.AccountNo,
        ifsc: values?.IFSCCode,
        bankName: values?.BankName,
      },
    };
    let data3 = {
      personalDetailsDto: {
        mobilePhone: values?.AlternateContacNo,
        phone: values?.ContactNo,
        emailId: values?.EmailId,
        name: values?.Name,
        dob: convertToDate(values?.Dob?._d),
        permanentAddressLine1: values?.ResidentialAddressLine1,
        permanentAddressLine2: values?.ResidentialAddressLine2,
        permanentAddressPincode: values?.PINCode,
        permanentAddressCity: values?.City,
        permanentAddressState: values?.State,
        residentialAddressLine1: values?.ResidentialAddressLine10,
        residentialAddressLine2: values?.ResidentialAddressLine20,
        residentialAddressPincode: values?.PINCode1,
        residentialAddressCity: values?.City1,
        residentialAddressState: values?.State1,
        educationalQualification: values?.EducationalQualification,
        maritalStatus: values?.MarriageStatus,
        marriageDate: convertToDate(values?.MarriageDate?._d),
      },
    };
    let data4 = {
      miscellaneousDetailsDto: {
        experienceInCourierIndustry: +values?.Experience,
        previousCourierCompanyName: values?.previousCompany,
        monthlyTurnover: +values?.MonthlyTurnover,
        officeOwnership: values?.OwnerShip,
        officeArea: values?.officeArea,
        noOfStaff: +values?.staff,
        checkVehicleAvailability: values?.checkVehicleAvailability,
        numberOfVehicles: values?.numberOfVehicles,
      },
    };
    let tempArea = [];

    for (let k = 0; k < formValues.length; k++) {
      tempArea.push({
        cpPincode: values?.CPPin,
        pincodeServiceabilityType: values["service" + formValues[k].id],
        deliveryPin: values["CPPin" + formValues[k].id],
        serviceableAreas: values["Areaname" + formValues[k].id],
        nonServiceableAreas: "na1, na2",
      });
    }
    let data5 = {
      deliveryDetailsDtos: tempArea,
    };
    let data0 = {
      premiseDto: {
        premiseName: values?.CPname,
        cpType: values?.CPtype,

        rateCardType: values?.RateCardType,
        addressLine1: values?.AddressLine1,
        addressLine2: values?.AddressLine2,
        pincode: +values?.PINcode,
        city: values?.City,
        state: values?.StateName,
        stateCode: values?.StateCode,
        longitude: values?.Longitude,
        latitude: values?.Latitude,
        zone: values?.hubZoon,
        billingCycle: values?.billingCycle,
        parentPremiseName: values?.MotherHubName,
        // hubType: "Mother Hub",
        mineHubConnected:
          values?.mineHubConnected == null ? false : values?.mineHubConnected,
        mineHubName:
          values?.mineHubConnected == null || false ? null : values?.miniHub,
      },
    };
    dispatch(
      patchOnboardForm(
        itemkey === 1
          ? data2
          : itemkey === 2
          ? data3
          : itemkey === 4
          ? data4
          : itemkey === 3
          ? data5
          : itemkey === 0
          ? data0
          : "",
        userData?.userName,
        apiResponse?.premiseId
      )
    );
  };
  const handleCancel = () => {
    setVisible(false);
    // form.resetFields();
  };
  const disabledDateNext = (current) => {
    return current > moment().startOf("day");
  };

  let firmInitialValues = {
    nameOfProprietor: apiResponse?.miscellaneousDto?.proprietorName,
    IsGSTRegistered: apiResponse?.miscellaneousDto?.gstRegistred?.toString(),
    FirmType: apiResponse?.miscellaneousDto?.firmType,
    MSME: apiResponse?.miscellaneousDto?.msme?.toString(),
    PANNumber: apiResponse?.premiseDto?.pan,
    AccountHolderName: apiResponse?.miscellaneousDto?.accountHolderName,
    AccountNo: apiResponse?.miscellaneousDto?.accountNo,
    IFSCCode: apiResponse?.miscellaneousDto?.ifsc,
    BankName: apiResponse?.miscellaneousDto?.bankName,
    GSTnumber: apiResponse?.premiseDto?.gst,
    NameOfFirm: apiResponse?.miscellaneousDto?.firmName,
  };
  let personalInitialValues = {
    Name: apiResponse?.miscellaneousDto?.name,
    ContactNo: apiResponse?.premiseDto?.phone,
    AlternateContacNo: apiResponse?.premiseDto?.mobilePhone,
    EmailId: apiResponse?.premiseDto?.emailId,
    EmailId2: apiResponse?.premiseDto?.personalEmailId,
    Dob: apiResponse?.miscellaneousDto?.dob
      ? moment(new Date(apiResponse?.miscellaneousDto?.dob), "DD-MM-YYYY")
      : null,
    ResidentialAddressLine1:
      apiResponse?.miscellaneousDto?.residentialAddressLine1,
    ResidentialAddressLine2:
      apiResponse?.miscellaneousDto?.residentialAddressLine2,
    PINCode: apiResponse?.miscellaneousDto?.residentialAddressPincode,
    City: apiResponse?.miscellaneousDto?.residentialAddressCity,
    State: apiResponse?.miscellaneousDto?.residentialAddressState,
    EducationalQualification:
      apiResponse?.miscellaneousDto?.educationalQualification,
    MarriageStatus: apiResponse?.miscellaneousDto?.maritalStatus,
    ResidentialAddressLine10:
      apiResponse?.miscellaneousDto?.residentialAddressLine1,
    ResidentialAddressLine20:
      apiResponse?.miscellaneousDto?.residentialAddressLine2,
    PINCode1: apiResponse?.miscellaneousDto?.residentialAddressPincode,
    City1: apiResponse?.miscellaneousDto?.residentialAddressCity,
    State1: apiResponse?.miscellaneousDto?.residentialAddressState,
  };
  let miscellaneousInitialValues = {
    Experience: apiResponse?.miscellaneousDto?.experienceInCourierIndustry,
    previousCompany: apiResponse?.miscellaneousDto?.previousCourierCompanyName,
    MonthlyTurnover: apiResponse?.miscellaneousDto?.monthlyTurnover,
    OwnerShip: apiResponse?.miscellaneousDto?.officeOwnership,
    officeArea: apiResponse?.miscellaneousDto?.officeArea,
    staff: apiResponse?.miscellaneousDto?.noOfStaff,
    checkVehicleAvailability:
      apiResponse?.miscellaneousDto?.checkVehicleAvailability,
    numberOfVehicles: apiResponse?.miscellaneousDto?.numberOfVehicles,
  };

  let cpInitialValues = {
    CPname: apiResponse?.premiseDto?.premiseName,
    CPtype: apiResponse?.premiseDto?.cpType,
    parentId: apiResponse?.premiseDto?.parentId,
    RateCardType: apiResponse?.premiseDto?.rateCardType,
    AddressLine1: apiResponse?.premiseDto?.addressLine1,
    AddressLine2: apiResponse?.premiseDto?.addressLine2,
    PINcode: apiResponse?.premiseDto?.pincode,
    City: apiResponse?.premiseDto?.city,
    StateName: apiResponse?.premiseDto?.state,
    StateCode: apiResponse?.premiseDto?.stateCode,
    Longitude: apiResponse?.premiseDto?.longitude,
    Latitude: apiResponse?.premiseDto?.latitude,
    hubZoon: apiResponse?.premiseDto?.zone,
    billingCycle: apiResponse?.premiseDto?.billingCycle,
    MotherHubName: apiResponse?.premiseDto?.parentPremiseName,
    mineHubConnected: apiResponse?.premiseDto?.mineHubConnected,
    miniHub: apiResponse?.premiseDto?.mineHubName,
  };

  let deliveryDetails = {
    CPPin: apiResponse?.premiseDto?.deliveryPincodes[0]?.cpPincode,
  };

  useEffect(() => {
    if (key === 1) {
      form.setFieldsValue(firmInitialValues);
    } else if (key === 2) {
      form.setFieldsValue(personalInitialValues);
    } else if (key === 4) {
      form.setFieldsValue(miscellaneousInitialValues);
    } else if (key === 3) {
      let arr = apiResponse?.premiseDto?.deliveryPincodes;

      form.setFieldValue("CPPin", apiResponse?.premiseDto?.pincode);
      let temp = [];
      for (let i = 0; i < arr.length; i++) {
        temp.push({
          id: Math.random().toString(36).slice(2),
          pinCode: "",
          areaName: [],
          disabledAreaName: [],
        });
      }
      setFormValues(temp);
      for (let j = 0; j < temp.length; j++) {
        form.setFieldValue("CPPin" + temp[j].id, arr[j].deliveryPin);
        form.setFieldValue(
          "service" + temp[j].id,
          arr[j].pincodeServiceabilityType
        );
        form.setFieldValue("Areaname" + temp[j].id, arr[j].serviceableAreas);
      }
      form.setFieldValue("CPPin" + 0, apiResponse?.premiseDetails?.pincode);
      form.setFieldValue("CPPin" + 0, apiResponse?.premiseDetails?.pincode);
    } else if (key === 0) {
      form.setFieldsValue(cpInitialValues);
    }
  }, [key, visible]);

  const formPropsfirmDetails = {
    name: "firmDetailsEdit",
    // className: "register-form",
    // onFinish: onSubmitFormData,
    autoComplete: "off",
  };

  const formFailed = (e) => {
    console.log(e);
  };

  return (
    <Spin spinning={loading}>
      <div
        style={{
          paddingBottom: "15px",
          paddingTop: "10px",
        }}
      >
        {/* <div
          className="view-details-header"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="view-details-header-text">{text}</div>
          {userData?.type !== "HUB" && (
            <div style={{ padding: "5px 10px 0 0" }}>
              <Space size="middle">
                {itemkey !== 9 && (
                  <Tooltip title={"Edit"} className="pointer">
                    <img
                      src={edit_icon}
                      alt="edit"
                      onClick={() => showModal(itemkey)}
                    />
                  </Tooltip>
                )}
              </Space>
            </div>
          )}
        </div> */}
        <Modal
          open={visible}
          onCancel={handleCancel}
          width={1000}
          destroyOnClose={true}
          maskClosable={false}
          footer={
            <>
              <Button
                onClick={handleCancel}
                className="next-button"
                style={{
                  borderRadius: "5px",
                  background: "white",
                  color: "#2E77D0",
                  borderRadius: "5px",

                  // backgroundColor: "#2e77d0",
                  marginRight: "8px",
                  border: "1px solid #2e77d0",
                  borderRadius: "4px",
                  width: "100px",
                  height: "40px",
                  fontWeight: "400",
                }}
              >
                {"CANCEL"}
              </Button>
              <Button
                htmlType="submit"
                form={form}
                className="next-button"
                // style={{ borderRadius: "5px" }}
                // onClick={form.handleSubmit}
                style={{
                  background: "#2E77D0",
                  color: "white",
                  borderRadius: "5px",

                  backgroundColor: "#2e77d0",
                  marginRight: "8px",
                  border: "1px solid #2e77d0",
                  borderRadius: "4px",
                  width: "100px",
                  height: "40px",
                  fontWeight: "400",
                }}
              >
                {"SUBMIT"}
              </Button>
            </>
          }
        >
          {" "}
          {itemkey === 1 ? (
            <Form
              formProps={formPropsfirmDetails}
              name={form}
              autoComplete="off"
              layout={"vertical"}
              onFinish={handleSubmit}
              onFinishFailed={formFailed}
              form={form}
              scrollToFirstError={{
                behavior: "smooth",
                block: "center",
                inline: "center",
              }}
              className="global-form"
              // initialValues={firmInitialValues}
            >
              {/* Any input */}
              <FirmInputDetails
                form={form}
                editDetails={firmInitialValues}
                itemkey={itemkey}
              />
              <FirmBankDetails form={form} />
            </Form>
          ) : itemkey === 2 ? (
            <Form
              formProps={formPropsfirmDetails}
              // initialValues={firmInitialValues}
              name={form}
              autoComplete="off"
              layout={"vertical"}
              onFinish={handleSubmit}
              form={form}
              scrollToFirstError={{
                behavior: "smooth",
                block: "center",
                inline: "center",
              }}
              className="global-form"
              // initialValues={personalInitialValues}
            >
              <PersonalInputDetails
                form={form}
                disabledDateNext={disabledDateNext}
              />
              <PersonalAddress
                form={form}
                setLoading={setLoading}
                disabledDateNext={disabledDateNext}
              />
            </Form>
          ) : itemkey === 3 ? (
            <Form
              formProps={formPropsfirmDetails}
              // initialValues={firmInitialValues}
              name={form}
              autoComplete="off"
              layout={"vertical"}
              onFinish={handleSubmit}
              form={form}
              scrollToFirstError={{
                behavior: "smooth",
                block: "center",
                inline: "center",
              }}
              className="global-form"
              // initialValues={deliveryDetails}
            >
              <EditDeliveryDetails
                form={form}
                formValues={formValues}
                setFormValues={setFormValues}
                apiResponse={apiResponse}
                visible={visible}
                itemkey={itemkey}
              />
            </Form>
          ) : itemkey === 4 ? (
            <Form
              formProps={formPropsfirmDetails}
              // initialValues={miscellaneousInitialValues}
              name={form}
              autoComplete="off"
              layout={"vertical"}
              onFinish={handleSubmit}
              form={form}
              scrollToFirstError={{
                behavior: "smooth",
                block: "center",
                inline: "center",
              }}
              className="global-form"
            >
              <MiscellaneousInput
                form={form}
                details={miscellaneousInitialValues}
                itemkey={itemkey}
              />
              {/* <MiscellaneousDetails /> */}
            </Form>
          ) : itemkey === 0 ? (
            <Form
              formProps={formPropsfirmDetails}
              name={form}
              autoComplete="off"
              layout={"vertical"}
              onFinish={handleSubmit}
              form={form}
              scrollToFirstError={{
                behavior: "smooth",
                block: "center",
                inline: "center",
              }}
              className="global-form"
              // initialValues={firmInitialValues}
            >
              {/* Any input */}
              <BasicDetails form={form} isEdit={cpInitialValues} />
              <AddressDetails form={form} />
            </Form>
          ) : (
            ""
          )}
        </Modal>
      </div>
    </Spin>
  );
}
